import CustomGrid from "../../../common/CustomGrid"
import { decimalPlace } from "../utils"


let ColumnData = [
    // { field: 'currency', headerText: 'Instrument', width: '' },
    { field: 'balance', headerText: 'Balance', width: '', format: decimalPlace() },
    { field: 'openPL', headerText: 'PnL', width: '' },
    { field: 'freeMargin', headerText: 'Margin', width: '' },
    // { field: 'credit', headerText: 'Credit', width: '', format: decimalPlace() },
    // { field: '', headerText: 'Free Margin', width: '', empty: true },
]

function AccountWallet({ apiData = [], isLoading }) {

    return (
        <>
            <CustomGrid ColumnData={ColumnData} apiData={Array.isArray([apiData]) && [apiData]} isLoading={isLoading} allowPaging={false} />
        </>
    )
}

export default AccountWallet